import { passLifecycleStatus, type PassEligibilityFields, type PassLifecycleStatus } from "../worker/src/domain";

export type PassDisplayStatus = PassLifecycleStatus;

export function passDisplayStatus(pass: PassEligibilityFields, today: string): PassDisplayStatus {
  return passLifecycleStatus(pass, today);
}

export function passStatusLabel(status: PassDisplayStatus, language: "zh" | "en"): string {
  const labels = language === "zh"
    ? { not_activated: "尚未啟用", active: "有效", expired: "已到期", used_up: "已用完", cancelled: "已取消" }
    : { not_activated: "Not activated", active: "Active", expired: "Expired", used_up: "Used up", cancelled: "Cancelled" };
  return labels[status];
}